import { Maybe } from '@pylot-data/pylotschema'

const imageURLRegex = /(http(s?):)([/|.|\w|\s|-])*\.(?:\w+)/g

export const getImagesURLFromString = (
    content: string | undefined
): string[] => {
    if (!content) return []

    const imageURLS =
        content
            .match(imageURLRegex)
            ?.filter((url) => /^https?:\/\/.+\.(jpg|jpeg|png)$/.test(url)) || []

    // Exclude URLs embedded inside lazy-load blocks (same logic on server and client)
    const lazyLoadBlocks =
        content.match(/class="[^"]*lazy-load[^"]*"[^>]*>[\s\S]*?<\/[^>]+>/gi) ||
        []

    if (lazyLoadBlocks.length === 0) {
        return imageURLS
    }

    const lazyImagesURL = lazyLoadBlocks
        .flatMap((block) => block.match(imageURLRegex) || [])
        .filter((url) => /^https?:\/\/.+\.(jpg|jpeg|png)$/.test(url))

    const filteredImageUrls = imageURLS.filter(
        (url) => !lazyImagesURL.includes(url)
    )

    return filteredImageUrls.length > 0 ? filteredImageUrls : imageURLS
}

export const optimizeImages = (
    content: Maybe<string> | undefined,
    quality = 70,
    auto = 'webp',
    imageFormat = 'pjpg'
): string | undefined => {
    if (content) {
        let optimizedContent = content
        const imageURLS = getImagesURLFromString(content)
        const optimizeURLParams = `?quality=${quality}&auto=${auto}&format=${imageFormat}`
        if (imageURLS) {
            for (const url of imageURLS) {
                optimizedContent = optimizedContent.replace(
                    url,
                    url.concat(optimizeURLParams)
                )
            }
        }

        return optimizedContent
    }
}
